<template>
  <article class="page--cms page--spaced">
    <div class="grid-container">
      <div class="grid-x grid-padding-x">
        <div class="cell auto">
          <Loader centered :loading="fetching">
            <component :is="getComponentForType(article.type)"
                       v-if="article"
                       :article="article"
                       class="cms-article" />
          </Loader>
        </div>
        <div v-if="showMenu" class="cell show-for-medium medium-4 large-offset-1">
          <CmsMenu :items="menuItems" :level="1" />
          <Marketing id="marketing" position="aside" />
        </div>
      </div>
    </div>
  </article>
</template>

<script>
  import get from 'lodash/get'
  import PrismicDOM from 'prismic-dom'
  import Page from '~/components/frontend/page'
  import Loader from '~/libs/queue/components/frontend/loader'
  import CmsMenu from '~/modules/cms/components/menu'
  import Marketing from '~/modules/marketing/components/frontend/marketing'
  import { warn } from '~/utils/errors'
  import i18n from './locales'

  export default {
    name: 'CmsArticlePage',
    extends: Page,
    i18n,
    middleware: [
      // Redirect to to "How it Works" article if current URI is just /info
      function ({ redirect, route }) {
        if (route.path === '/info' || route.path === '/info/') {
          redirect('/info/how-it-works')
        }
      },
    ],
    components: {
      CmsMenu,
      Loader,
      Marketing,

      // Template components.
      Cards: () => import('~/modules/cms/components/templates/cards'),
      HowItWorks: () => import('~/modules/cms/components/templates/how-it-works'),
      Mfi: () => import('~/modules/cms/components/templates/mfi'),
      Plain: () => import('~/modules/cms/components/templates/plain'),
      Rich: () => import('~/modules/cms/components/templates/rich'),
    },
    data () {
      return {
        fetching: true,
      }
    },
    computed: {
      article () {
        return this.$store.getters['cms/article']
      },
      contentClassNames () {
        if (this.showMenu) return ['small-12', 'medium-8', 'large-7']

        return ['small-12']
      },
      menuItems () {
        return this.$get(this.$store.getters['cms/structure'], 'children', [])
      },
      showMenu () {
        if (!this.article) return true

        return get(this.article, 'data.has-menu', 'Yes') === 'Yes'
      },
      subheader () {
        return {
          heading: PrismicDOM.RichText.asText(this.$get(this.article, 'data.title', [])),
          extraClasses: ''
        }
      },
    },
    methods: {
      getComponentForType (type) {
        if (!type) return null

        switch (type) {
          case 'cards':
            return this.$options.components.Cards
          case 'how_it_work':
            return this.$options.components.HowItWorks
          case 'mfi':
            return this.$options.components.Mfi
          case 'plain':
            return this.$options.components.Plain
          case 'rich':
            return this.$options.components.Rich
          default:
            warn(`Unknown template: ${type}.`)
        }
      },
      async fetchArticle () {
        try {
          await this.$store.dispatch('cms/fetchArticle', { uri: this.$route.path })
        } catch (err) {
          this.$notify({ type: 'error', text: this.$t('loadingError') })
        } finally {
          this.fetching = false
        }
      },
    },
    created () {
      this.fetchArticle()
    },
  }
</script>

<style lang="scss">
  .page--cms {
    @import "~assets/scss/frontend/extras/_cms";

    #marketing {
      margin-top: 1rem;
    }
  }
</style>
